export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ConvertableFloat: { input: any; output: any; }
  ConvertableInt: { input: any; output: any; }
  ConvertableLong: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Guid: { input: any; output: any; }
  Long: { input: any; output: any; }
  NullableObjectIdType: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
  UInt: { input: any; output: any; }
  _Any: { input: any; output: any; }
};

export enum AuditActionType {
  ADD = 'ADD',
  DATA_EXPORT = 'DATA_EXPORT',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
  UPDATE = 'UPDATE'
}

export enum AuditApplicationArea {
  ADMIN = 'ADMIN',
  CENTRAL_MONITORING = 'CENTRAL_MONITORING',
  CENTRAL_MONITORING_2 = 'CENTRAL_MONITORING_2',
  DATA_QUALITY = 'DATA_QUALITY',
  IMPORT = 'IMPORT',
  ISMP = 'ISMP',
  OPRA = 'OPRA',
  OPRA_PLUGIN = 'OPRA_PLUGIN',
  ORGANISATION = 'ORGANISATION',
  PANEL = 'PANEL',
  REPORT = 'REPORT',
  RISK_ASSESSMENT = 'RISK_ASSESSMENT',
  SITE = 'SITE',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT',
  SUBJECT_MONITORING = 'SUBJECT_MONITORING',
  SUBJECT_MONITORING_REVIEW = 'SUBJECT_MONITORING_REVIEW'
}

export enum AuditDataType {
  ACTIONS = 'ACTIONS',
  ALL = 'ALL',
  CENTRAL_MONITORING_OBSERVATION = 'CENTRAL_MONITORING_OBSERVATION',
  CENTRAL_MONITORING_OBSERVATION_ACTION = 'CENTRAL_MONITORING_OBSERVATION_ACTION',
  CM_2_ACTION = 'CM_2_ACTION',
  CM_2_OBSERVATION = 'CM_2_OBSERVATION',
  CM_2_REVIEW_LOG = 'CM_2_REVIEW_LOG',
  CM_INTEGRATION_CONFIG = 'CM_INTEGRATION_CONFIG',
  CONTROLS = 'CONTROLS',
  CONTROLS_HUB_CONFIG_PANEL = 'CONTROLS_HUB_CONFIG_PANEL',
  CONTROLS_HUB_CONFIG_WIDGET = 'CONTROLS_HUB_CONFIG_WIDGET',
  CONTROLS_HUB_WIDGET = 'CONTROLS_HUB_WIDGET',
  CRITICAL_VARIABLE = 'CRITICAL_VARIABLE',
  CTQ_COMMENT = 'CTQ_COMMENT',
  CTQ_COMMENT_REPLY = 'CTQ_COMMENT_REPLY',
  DASHBOARD = 'DASHBOARD',
  DASHBOARDS = 'DASHBOARDS',
  DATASET_IMPORT_LOG = 'DATASET_IMPORT_LOG',
  DATA_PROCESSING_LOG = 'DATA_PROCESSING_LOG',
  DATA_QUALITY_REPORT = 'DATA_QUALITY_REPORT',
  DATA_REVIEW_TABLE = 'DATA_REVIEW_TABLE',
  DATA_SET = 'DATA_SET',
  DATA_SET_REVIEW = 'DATA_SET_REVIEW',
  DATA_SOURCE = 'DATA_SOURCE',
  DATA_VIEW_CONFIGURATION = 'DATA_VIEW_CONFIGURATION',
  DATA_VIEW_FILTER = 'DATA_VIEW_FILTER',
  EXCEL_EXPORT = 'EXCEL_EXPORT',
  EXCEL_LISTING = 'EXCEL_LISTING',
  EXTRA_DATA_FIELD = 'EXTRA_DATA_FIELD',
  FUNCTIONAL_DATA_REVIEW = 'FUNCTIONAL_DATA_REVIEW',
  IMPORT_STATE = 'IMPORT_STATE',
  INDICATORS = 'INDICATORS',
  INVESTIGATOR = 'INVESTIGATOR',
  ISMP = 'ISMP',
  KRI_REVIEW = 'KRI_REVIEW',
  LIBRARY_CONTROL = 'LIBRARY_CONTROL',
  LIBRARY_FUNCTIONAL_DATA_REVIEW = 'LIBRARY_FUNCTIONAL_DATA_REVIEW',
  LIBRARY_RISK = 'LIBRARY_RISK',
  LOCATION = 'LOCATION',
  LO_VS = 'LO_VS',
  NAMED_ITEM = 'NAMED_ITEM',
  OBSERVATIONS = 'OBSERVATIONS',
  ORGANISATION = 'ORGANISATION',
  ORGANISATION_CONTACT = 'ORGANISATION_CONTACT',
  ORGANISATION_INDICATION = 'ORGANISATION_INDICATION',
  ORGANISATION_MEMBER = 'ORGANISATION_MEMBER',
  ORGANISATION_PRODUCT = 'ORGANISATION_PRODUCT',
  ORGANISATION_PROGRAM = 'ORGANISATION_PROGRAM',
  ORGANISATION_ROLE = 'ORGANISATION_ROLE',
  PANEL = 'PANEL',
  PBICM_2_REPORT_SIGNATORY = 'PBICM_2_REPORT_SIGNATORY',
  PBICM_REPORT_SIGNATORY = 'PBICM_REPORT_SIGNATORY',
  PBIOPRA_REPORT_TEMPLATE = 'PBIOPRA_REPORT_TEMPLATE',
  PBIRAM_REPORT_SIGNATORY = 'PBIRAM_REPORT_SIGNATORY',
  PBISM_REPORT_SIGNATORY = 'PBISM_REPORT_SIGNATORY',
  PBI_CUSTOM_REPORT_TEMPLATE = 'PBI_CUSTOM_REPORT_TEMPLATE',
  PBI_REPORT = 'PBI_REPORT',
  PBI_RISK_REVIEW = 'PBI_RISK_REVIEW',
  PBI_RISK_REVIEW_ATTENDEE = 'PBI_RISK_REVIEW_ATTENDEE',
  PLUGIN = 'PLUGIN',
  PROTOCOL_DOCUMENT = 'PROTOCOL_DOCUMENT',
  REPORT = 'REPORT',
  REPORT_DEFINITION = 'REPORT_DEFINITION',
  REPORT_SIGNATORY = 'REPORT_SIGNATORY',
  REVIEW_POINTS = 'REVIEW_POINTS',
  RISKS = 'RISKS',
  RISK_ACTION = 'RISK_ACTION',
  RISK_ASSESSMENT_TAG = 'RISK_ASSESSMENT_TAG',
  RISK_COMMENT = 'RISK_COMMENT',
  RISK_COMMENT_REPLY = 'RISK_COMMENT_REPLY',
  RISK_DASHBOARD_SETUP = 'RISK_DASHBOARD_SETUP',
  RISK_EVALUATION = 'RISK_EVALUATION',
  RISK_EVALUATION_MODEL = 'RISK_EVALUATION_MODEL',
  RISK_IQ_CTQ_COMMENT = 'RISK_IQ_CTQ_COMMENT',
  RISK_IQ_CTQ_COMMENT_REPLY = 'RISK_IQ_CTQ_COMMENT_REPLY',
  RISK_IQ_RISK_COMMENT = 'RISK_IQ_RISK_COMMENT',
  RISK_IQ_RISK_COMMENT_REPLY = 'RISK_IQ_RISK_COMMENT_REPLY',
  RISK_OBSERVATION = 'RISK_OBSERVATION',
  SITE = 'SITE',
  SITE_ISSUE = 'SITE_ISSUE',
  SITE_PROTOCOL_DEVIATION = 'SITE_PROTOCOL_DEVIATION',
  SITE_REVIEW = 'SITE_REVIEW',
  SITE_VISIT = 'SITE_VISIT',
  SM_STUDY_MEMBER = 'SM_STUDY_MEMBER',
  STUDY = 'STUDY',
  STUDY_ASSESSMENT = 'STUDY_ASSESSMENT',
  STUDY_COHORT = 'STUDY_COHORT',
  STUDY_CONTROL = 'STUDY_CONTROL',
  STUDY_COUNTRY = 'STUDY_COUNTRY',
  STUDY_CRF = 'STUDY_CRF',
  STUDY_DASHBOARD_CONFIG = 'STUDY_DASHBOARD_CONFIG',
  STUDY_DASHBOARD_CONFIGURATION = 'STUDY_DASHBOARD_CONFIGURATION',
  STUDY_DASHBOARD_CONFIG_PANEL = 'STUDY_DASHBOARD_CONFIG_PANEL',
  STUDY_DASHBOARD_CONFIG_WIDGET = 'STUDY_DASHBOARD_CONFIG_WIDGET',
  STUDY_HUB_SITE_FIELDS = 'STUDY_HUB_SITE_FIELDS',
  STUDY_HUB_STUDY_FIELDS = 'STUDY_HUB_STUDY_FIELDS',
  STUDY_MEMBER = 'STUDY_MEMBER',
  STUDY_SUBJECT_VISIT_OVER_TIME = 'STUDY_SUBJECT_VISIT_OVER_TIME',
  STUDY_SUBJECT_VISIT_SCHEDULE_TEMPLATE = 'STUDY_SUBJECT_VISIT_SCHEDULE_TEMPLATE',
  STUDY_TREATMENT_ARM = 'STUDY_TREATMENT_ARM',
  SUBJECT = 'SUBJECT',
  SUBJECT_ACTIONS = 'SUBJECT_ACTIONS',
  SUBJECT_ADVERSE_EVENT = 'SUBJECT_ADVERSE_EVENT',
  SUBJECT_ASSESSMENT = 'SUBJECT_ASSESSMENT',
  SUBJECT_CONCOMITANT_MEDICATION = 'SUBJECT_CONCOMITANT_MEDICATION',
  SUBJECT_CRF = 'SUBJECT_CRF',
  SUBJECT_DATA_LISTING_REVIEW = 'SUBJECT_DATA_LISTING_REVIEW',
  SUBJECT_INFORMED_CONSENT = 'SUBJECT_INFORMED_CONSENT',
  SUBJECT_ISSUE = 'SUBJECT_ISSUE',
  SUBJECT_LAB = 'SUBJECT_LAB',
  SUBJECT_MEDICAL_HISTORY = 'SUBJECT_MEDICAL_HISTORY',
  SUBJECT_MONITORING_DATA_LISTINGS_CONFIG = 'SUBJECT_MONITORING_DATA_LISTINGS_CONFIG',
  SUBJECT_MONITORING_REVIEW = 'SUBJECT_MONITORING_REVIEW',
  SUBJECT_MONITORING_REVIEW_PLAN = 'SUBJECT_MONITORING_REVIEW_PLAN',
  SUBJECT_MONITORING_REVIEW_TYPE = 'SUBJECT_MONITORING_REVIEW_TYPE',
  SUBJECT_MONITORING_SUBJECT_HUB_OVERVIEW_GRID_CONFIG = 'SUBJECT_MONITORING_SUBJECT_HUB_OVERVIEW_GRID_CONFIG',
  SUBJECT_OBSERVATIONS = 'SUBJECT_OBSERVATIONS',
  SUBJECT_PROFILE_DETAILS_CONFIGURATION = 'SUBJECT_PROFILE_DETAILS_CONFIGURATION',
  SUBJECT_PROTOCOL_DEVIATION = 'SUBJECT_PROTOCOL_DEVIATION',
  SUBJECT_QUERY = 'SUBJECT_QUERY',
  SUBJECT_REVIEW_INSTANCE = 'SUBJECT_REVIEW_INSTANCE',
  SUBJECT_REVIEW_LOGS = 'SUBJECT_REVIEW_LOGS',
  SUBJECT_VISIT = 'SUBJECT_VISIT',
  SYSTEM_ORGANISATION = 'SYSTEM_ORGANISATION',
  TAG = 'TAG',
  TAG_INSTANCE = 'TAG_INSTANCE',
  USERS = 'USERS',
  WIDGET = 'WIDGET'
}

export type AuditSearchConditionInput = {
  field?: InputMaybe<AuditSearchField>;
  operator?: InputMaybe<AuditSearchOperator>;
  value?: InputMaybe<Scalars['String']['input']>;
  value2?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum AuditSearchField {
  AUDIT_ACTION = 'AUDIT_ACTION',
  AUDIT_AREA = 'AUDIT_AREA',
  AUDIT_CREATED = 'AUDIT_CREATED',
  AUDIT_DATA_TYPE = 'AUDIT_DATA_TYPE',
  AUDIT_DESCRIPTION = 'AUDIT_DESCRIPTION',
  AUDIT_REASON = 'AUDIT_REASON',
  AUDIT_RECORD_ID = 'AUDIT_RECORD_ID',
  AUDIT_STUDY_ID = 'AUDIT_STUDY_ID',
  AUDIT_USER_EMAIL = 'AUDIT_USER_EMAIL',
  AUDIT_USER_FIRSTNAME = 'AUDIT_USER_FIRSTNAME',
  AUDIT_USER_ID = 'AUDIT_USER_ID',
  AUDIT_USER_LAST_NAME = 'AUDIT_USER_LAST_NAME'
}

export enum AuditSearchOperator {
  AND = 'AND',
  OR = 'OR'
}

export enum AuditServiceType {
  CENTRAL_MONITORING_2 = 'CENTRAL_MONITORING_2',
  CORE = 'CORE',
  REPORTING = 'REPORTING',
  SUBJECT_MONITORING = 'SUBJECT_MONITORING'
}

export enum Authentication {
  OPRA = 'OPRA',
  SSO = 'SSO'
}

export enum AutomationRange {
  ALL = 'ALL',
  SPECIFIC_RANGE = 'SPECIFIC_RANGE'
}

export type AxisInput = {
  dateSeries?: InputMaybe<Array<DateSeriesInput>>;
  numericSeries?: InputMaybe<Array<NumericSeriesInput>>;
  title: Scalars['String']['input'];
  type: TimelineAxisType;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CentralMonitoringObservationActionInput = {
  actionTaken?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedCompleteDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  observationId?: InputMaybe<Scalars['ObjectId']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectId']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  requestDate?: InputMaybe<Scalars['Date']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  rootCause?: InputMaybe<Scalars['String']['input']>;
};

export enum CentralMonitoringObservationArea {
  PANEL = 'PANEL',
  RISK_OVERVIEW = 'RISK_OVERVIEW',
  SITE_OVERVIEW = 'SITE_OVERVIEW',
  SITE_SUMMARY = 'SITE_SUMMARY',
  STUDY_OVERVIEW = 'STUDY_OVERVIEW'
}

export type CentralMonitoringObservationInput = {
  closedDate?: InputMaybe<Scalars['Date']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  confirmedCause?: InputMaybe<Scalars['String']['input']>;
  dataSetId?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  observationDate?: InputMaybe<Scalars['Date']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectId']['input']>;
  panelId?: InputMaybe<Scalars['ObjectId']['input']>;
  potentialCause?: InputMaybe<Scalars['String']['input']>;
  qtlExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  siteId?: InputMaybe<Scalars['ObjectId']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<CentralMonitoringObservationArea>;
};

export type CloseCommentInput = {
  entityType: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
  replySelectors: Array<SelectorData>;
};

export type CommentSelector = {
  id: Scalars['ObjectId']['input'];
  replySelectors: Array<SelectorData>;
  version: Scalars['Int']['input'];
};

export type CommentsInput = {
  entityType: Scalars['String']['input'];
  parentId: Scalars['ObjectId']['input'];
};

export enum ConMedEndRelativeToReferencePeriod {
  AFTER = 'AFTER',
  BEFORE = 'BEFORE',
  DURING = 'DURING',
  NONE = 'NONE'
}

export enum ControlHubModelPeriodType {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  NONE = 'NONE',
  QUARTERS = 'QUARTERS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum ControlsAutomationColor {
  LOWER_AMBER_LOWER_RED = 'LOWER_AMBER_LOWER_RED',
  LOWER_RED = 'LOWER_RED',
  NONE = 'NONE',
  UPPER_AMBER_UPPER_RED = 'UPPER_AMBER_UPPER_RED',
  UPPER_RED = 'UPPER_RED',
  UPPER_RED_LOWER_AMBER_LOWER_RED = 'UPPER_RED_LOWER_AMBER_LOWER_RED',
  UPPER_RED_LOWER_RED = 'UPPER_RED_LOWER_RED',
  UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED = 'UPPER_RED_UPPER_AMBER_LOWER_AMBER_LOWER_RED',
  UPPER_RED_UPPER_AMBER_LOWER_RED = 'UPPER_RED_UPPER_AMBER_LOWER_RED'
}

export type ControlsHubConfigWidgetInputType = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  recordId?: InputMaybe<Scalars['Long']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  tableCode?: InputMaybe<Scalars['Int']['input']>;
  typeCode?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryInputType = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  content: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  parentId: Scalars['ObjectId']['input'];
};

export type CreateCommentReplyInput = {
  content: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  parentCommentId: Scalars['ObjectId']['input'];
  replySelectors: Array<SelectorData>;
};

export enum CriticalToQualityFactorWidgetType {
  NUMBER_ACTIVE = 'NUMBER_ACTIVE',
  NUMBER_ACTIVE_CRITICAL = 'NUMBER_ACTIVE_CRITICAL',
  NUMBER_ACTIVE_CTQS_WITHOUT_FUNCTIONAL_DATA_REVIEWS = 'NUMBER_ACTIVE_CTQS_WITHOUT_FUNCTIONAL_DATA_REVIEWS',
  NUMBER_ACTIVE_CTQS_WITHOUT_RISKS = 'NUMBER_ACTIVE_CTQS_WITHOUT_RISKS',
  NUMBER_TOTAL = 'NUMBER_TOTAL'
}

export type CriticalVariableInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  controls?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  dataSource?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  edcEntry?: InputMaybe<Scalars['String']['input']>;
  edcentryId?: InputMaybe<Scalars['ObjectId']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isCritical?: InputMaybe<Scalars['Boolean']['input']>;
  isIsmp?: InputMaybe<Scalars['Boolean']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  responsibleVendor?: InputMaybe<Scalars['String']['input']>;
  riqRejectionReason?: InputMaybe<Scalars['String']['input']>;
  riqSourceExcerpt?: InputMaybe<Scalars['String']['input']>;
  riqSourcePageNumber?: InputMaybe<Scalars['Int']['input']>;
  riqStatus?: InputMaybe<RiqStatusType>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<CriticalVariableType>;
  typeId?: InputMaybe<Scalars['ObjectId']['input']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export enum CriticalVariableType {
  BOTH = 'BOTH',
  DATA = 'DATA',
  NONE = 'NONE',
  PROCESS = 'PROCESS'
}

export type DashboardChildPanelInput = {
  index?: InputMaybe<Scalars['ConvertableInt']['input']>;
  panelId?: InputMaybe<Scalars['ObjectId']['input']>;
  panelRecordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
};

export type DashboardDataReviewInput = {
  dataReviewId?: InputMaybe<Scalars['ObjectId']['input']>;
  index?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export type DashboardInput = {
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  panels?: InputMaybe<Array<InputMaybe<DashboardParentPanelInput>>>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<DashboardType>;
};

export type DashboardParentPanelInput = {
  childPanels?: InputMaybe<Array<InputMaybe<DashboardChildPanelInput>>>;
  dataReviews?: InputMaybe<Array<InputMaybe<DashboardDataReviewInput>>>;
  index?: InputMaybe<Scalars['ConvertableInt']['input']>;
  panelId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum DashboardType {
  SITE = 'SITE',
  STUDY = 'STUDY'
}

export type DataListingsListItemInput = {
  datatableId?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['Int']['input']>;
};

export enum DataPopulation {
  ALL = 'ALL',
  MOST_RECENT = 'MOST_RECENT'
}

export type DataReviewTableColumnInput = {
  columnId?: InputMaybe<Scalars['ObjectId']['input']>;
  dataField?: InputMaybe<Scalars['String']['input']>;
  dataSource?: InputMaybe<Scalars['String']['input']>;
  denominatorField?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<DataReviewTableColumnLevel>;
  numeratorField?: InputMaybe<Scalars['String']['input']>;
  panelField?: InputMaybe<PanelFieldType>;
  panelId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<DataReviewTableColumnType>;
};

export enum DataReviewTableColumnLevel {
  COUNTRY = 'COUNTRY',
  NONE = 'NONE',
  SITE = 'SITE',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT'
}

export enum DataReviewTableColumnType {
  COUNT = 'COUNT',
  COUNTRY_MEAN = 'COUNTRY_MEAN',
  COUNTRY_MEDIAN = 'COUNTRY_MEDIAN',
  MAX = 'MAX',
  MIN = 'MIN',
  PANEL = 'PANEL',
  PERCENTAGE = 'PERCENTAGE',
  PERCENTILE = 'PERCENTILE',
  RATE = 'RATE',
  SITE_MEAN = 'SITE_MEAN',
  SITE_MEDIAN = 'SITE_MEDIAN',
  STANDARD_CALCULATION = 'STANDARD_CALCULATION',
  STATIC = 'STATIC',
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN',
  SUM = 'SUM'
}

export type DataReviewTableInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<DataReviewTableColumnInput>>>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  dataSource?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<DataReviewType>;
};

export enum DataReviewType {
  COUNTRY = 'COUNTRY',
  DATA = 'DATA',
  SITE = 'SITE',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT'
}

export enum DataStorageRegion {
  ALL = 'ALL',
  CUSTOM = 'CUSTOM',
  OPRA_EU = 'OPRA_EU',
  OPRA_US = 'OPRA_US'
}

export enum DataViewConfigValidation {
  CONFIG_COUNT_MISMATCH = 'CONFIG_COUNT_MISMATCH',
  CONFIG_ID_IN_USE = 'CONFIG_ID_IN_USE',
  FAILED = 'FAILED',
  INVALID_CONFIG_ID = 'INVALID_CONFIG_ID',
  INVALID_DATA_SOURCE = 'INVALID_DATA_SOURCE',
  INVALID_ID = 'INVALID_ID',
  INVALID_NAME = 'INVALID_NAME',
  IN_USE = 'IN_USE',
  MAIN_PANEL_IN_PANELS = 'MAIN_PANEL_IN_PANELS',
  MAIN_PANEL_IN_USE = 'MAIN_PANEL_IN_USE',
  NAME_IN_USE = 'NAME_IN_USE',
  SUCCESS = 'SUCCESS'
}

export type DataViewConfigurationInput = {
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  dataFilterIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  dataSource?: InputMaybe<RowDataSourceTable>;
  dataTableIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mainPanelId?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  panelIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  unfilterablePanelIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type DataViewFilterInput = {
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  dataSource?: InputMaybe<RowDataSourceTable>;
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum DataViewFilterValidation {
  CANT_DELETE_NON_REMOVABLE_FIELD_KEY = 'CANT_DELETE_NON_REMOVABLE_FIELD_KEY',
  CANT_UPDATE_DEFAULT_FIELD_KEY = 'CANT_UPDATE_DEFAULT_FIELD_KEY',
  CANT_UPDATE_NON_REMOVABLE_FIELD_KEY = 'CANT_UPDATE_NON_REMOVABLE_FIELD_KEY',
  FAILED = 'FAILED',
  FIELD_IN_USE = 'FIELD_IN_USE',
  FILTER_COUNT_MISMATCH = 'FILTER_COUNT_MISMATCH',
  INVALID_DATA_SOURCE = 'INVALID_DATA_SOURCE',
  INVALID_FILTER_ID = 'INVALID_FILTER_ID',
  LABEL_IN_USE = 'LABEL_IN_USE',
  SUCCESS = 'SUCCESS',
  UNKNOWN_ID = 'UNKNOWN_ID'
}

export type DateSeriesInput = {
  endField?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  label: Scalars['String']['input'];
  plotLabel: Scalars['String']['input'];
  rowData: SeriesRowDataInput;
  startField: Scalars['String']['input'];
  type: TimelineDateSeriesType;
};

export type DeleteCommentInput = {
  entityType: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
};

export type DeleteCommentReplyInput = {
  entityType: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
  replySelectors: Array<SelectorData>;
};

export enum EventRatesOTBenchmarkType {
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum EventRatesOTCountryBenchmarkType {
  COUNTRY_RATE = 'COUNTRY_RATE',
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum EventRatesOTThresholdType {
  FIXED = 'FIXED',
  LANEY_U_CHART = 'LANEY_U_CHART',
  QUASI_POISSON_U_CHART = 'QUASI_POISSON_U_CHART',
  U_CHART = 'U_CHART'
}

export type EventRatesOverTimeInput = {
  automationRange?: InputMaybe<AutomationRange>;
  benchmarkType?: InputMaybe<EventRatesOTBenchmarkType>;
  calcEndDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  calcStartDate?: InputMaybe<Scalars['String']['input']>;
  countryBenchmark?: InputMaybe<EventRatesOTCountryBenchmarkType>;
  cumulativeOrTimePeriod?: InputMaybe<ModelPlotCalculation>;
  denominatorName?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  expectedVolume?: InputMaybe<Scalars['Int']['input']>;
  lowerAmber?: InputMaybe<Scalars['Float']['input']>;
  lowerRed?: InputMaybe<Scalars['Float']['input']>;
  minSubjects?: InputMaybe<Scalars['Int']['input']>;
  minTimeOnStudyPeriod?: InputMaybe<ControlHubModelPeriodType>;
  minTimeOnStudyUnit?: InputMaybe<Scalars['Int']['input']>;
  numberOfTimePeriods?: InputMaybe<Scalars['Int']['input']>;
  numeratorName?: InputMaybe<Scalars['String']['input']>;
  plotBy?: InputMaybe<ModelPlotBy>;
  qtl?: InputMaybe<Scalars['Boolean']['input']>;
  reportOutOfTolerance?: InputMaybe<Scalars['Boolean']['input']>;
  rowData?: InputMaybe<Scalars['String']['input']>;
  rowDataDate?: InputMaybe<Scalars['String']['input']>;
  scaleBy?: InputMaybe<ModelScaleBy>;
  studySpecificBenchmark?: InputMaybe<Scalars['Float']['input']>;
  thresholdType?: InputMaybe<EventRatesOTThresholdType>;
  timepointDate?: InputMaybe<Scalars['String']['input']>;
  timepointsList?: InputMaybe<Scalars['String']['input']>;
  upperAmber?: InputMaybe<Scalars['Float']['input']>;
  upperRed?: InputMaybe<Scalars['Float']['input']>;
  xAxisPtsToShade?: InputMaybe<Scalars['Int']['input']>;
  xAxisTitle?: InputMaybe<Scalars['String']['input']>;
  yAxisTitle?: InputMaybe<Scalars['String']['input']>;
};

export enum EventType {
  EMAIL_SENT = 'EMAIL_SENT',
  LOGIN = 'LOGIN',
  LOGIN_ACCOUNT_DISABLED = 'LOGIN_ACCOUNT_DISABLED',
  LOGIN_ACCOUNT_INACTIVE = 'LOGIN_ACCOUNT_INACTIVE',
  LOGIN_ACCOUNT_LOCKED = 'LOGIN_ACCOUNT_LOCKED',
  LOGIN_INCORRECT_2_FA = 'LOGIN_INCORRECT_2_FA',
  LOGIN_INCORRECT_PASSWORD = 'LOGIN_INCORRECT_PASSWORD',
  LOGIN_SSO = 'LOGIN_SSO',
  LOGIN_SSO_INACTIVE_ORG_MEMBER = 'LOGIN_SSO_INACTIVE_ORG_MEMBER',
  LOGIN_SSO_NO_USER_INFO = 'LOGIN_SSO_NO_USER_INFO',
  LOGIN_SSO_UNKNOWN_ORG_MEMBER = 'LOGIN_SSO_UNKNOWN_ORG_MEMBER',
  LOGIN_SSO_USER_CREATED = 'LOGIN_SSO_USER_CREATED',
  LOGIN_UNKNOWN_EMAIL = 'LOGIN_UNKNOWN_EMAIL',
  LOGOUT = 'LOGOUT',
  SMS_SENT = 'SMS_SENT'
}

export type ExtraDataFieldInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  fieldType?: InputMaybe<FieldDefinitionFieldType>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  isCalculated?: InputMaybe<Scalars['Boolean']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  sourceFieldName?: InputMaybe<Scalars['String']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  table?: InputMaybe<RowDataSourceTable>;
};

export enum FieldDefinitionFieldType {
  BOOL = 'BOOL',
  DATE = 'DATE',
  FLOAT = 'FLOAT',
  INT = 'INT',
  PARTIAL_DATE = 'PARTIAL_DATE',
  TEXT = 'TEXT'
}

export enum FieldTag {
  SUBJECT_POPULATION = 'SUBJECT_POPULATION'
}

export type FunctionalDataReviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  criticalToQualityFactorId?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  libraryReferenceId?: InputMaybe<Scalars['ObjectId']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum Gender {
  F = 'F',
  M = 'M',
  NONE = 'NONE'
}

export type ISMPInput = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  monitoringStrategy?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum ImportAction {
  FAILED_TO_GENERATE_FIELDS = 'FAILED_TO_GENERATE_FIELDS',
  FAILED_TO_PROCESS_PANELS = 'FAILED_TO_PROCESS_PANELS',
  FINISH_GENERATE_FIELDS = 'FINISH_GENERATE_FIELDS',
  FINISH_IMPORT_DATA = 'FINISH_IMPORT_DATA',
  FINISH_PROCESS_PANELS = 'FINISH_PROCESS_PANELS',
  ROLLBACK_GENERATE_FIELDS = 'ROLLBACK_GENERATE_FIELDS',
  ROLLBACK_IMPORT = 'ROLLBACK_IMPORT',
  ROLLBACK_PROCESS_PANELS = 'ROLLBACK_PROCESS_PANELS',
  START_IMPORT_DATA = 'START_IMPORT_DATA'
}

export enum ImportCurrentState {
  COMPLETE = 'COMPLETE',
  DATA_IMPORTED = 'DATA_IMPORTED',
  FIELDS_GENERATED = 'FIELDS_GENERATED',
  IMPORTING_DATA = 'IMPORTING_DATA',
  ROLLED_BACK = 'ROLLED_BACK'
}

export type KeyValueInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LibraryControlInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  controlPhaseId?: InputMaybe<Scalars['ObjectId']['input']>;
  controlTypeId?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  organisationId?: InputMaybe<Scalars['ObjectId']['input']>;
  phase?: InputMaybe<PhaseType>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
  reviewFrequencyPeriod?: InputMaybe<Scalars['ConvertableInt']['input']>;
  reviewFrequencyUnits?: InputMaybe<TimeFrequencyType>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  systemReferenceId?: InputMaybe<Scalars['ObjectId']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ObjectId']['input']>;
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type LibraryFunctionalDataReviewInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type LibraryRiskDisplayOrderInputType = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  libraryRiskId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type LibraryRiskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  controlStrategyId?: InputMaybe<Scalars['ObjectId']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryInputType>>>;
  displayOrder?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  libraryControlIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  organisationId?: InputMaybe<Scalars['ObjectId']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
  reviewFrequencyPeriod?: InputMaybe<Scalars['Int']['input']>;
  reviewFrequencyUnits?: InputMaybe<TimeFrequencyType>;
  reviewRequired?: InputMaybe<Scalars['Boolean']['input']>;
  riskCategoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  riskLibraryCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  statement?: InputMaybe<Scalars['String']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  systemReferenceId?: InputMaybe<Scalars['ObjectId']['input']>;
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export enum LogLevel {
  CRITICAL = 'CRITICAL',
  DEBUG = 'DEBUG',
  ERROR = 'ERROR',
  INFORMATION = 'INFORMATION',
  NONE = 'NONE',
  TRACE = 'TRACE',
  WARNING = 'WARNING'
}

export enum ModelPlotBy {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export enum ModelPlotCalculation {
  BY_TIME_PERIOD = 'BY_TIME_PERIOD',
  CUMULATIVE = 'CUMULATIVE'
}

export enum ModelScaleBy {
  NONE = 'NONE',
  PER_10_SUBJECT_TIME_POINTS = 'PER_10_SUBJECT_TIME_POINTS',
  PER_10_SUBJECT_YEARS = 'PER_10_SUBJECT_YEARS',
  PER_100_SUBJECT_TIME_POINTS = 'PER_100_SUBJECT_TIME_POINTS',
  PER_100_SUBJECT_YEARS = 'PER_100_SUBJECT_YEARS',
  PER_1000_SUBJECT_TIME_POINTS = 'PER_1000_SUBJECT_TIME_POINTS',
  PER_1000_SUBJECT_YEARS = 'PER_1000_SUBJECT_YEARS',
  PER_SUBJECT_MONTH = 'PER_SUBJECT_MONTH',
  PER_SUBJECT_TIME_POINT = 'PER_SUBJECT_TIME_POINT',
  PER_SUBJECT_WEEK = 'PER_SUBJECT_WEEK',
  PER_SUBJECT_YEAR = 'PER_SUBJECT_YEAR',
  _1 = '_1',
  _10 = '_10',
  _100 = '_100',
  _1000 = '_1000'
}

export enum NamedItemType {
  CONTROLS_REVIEW_LOG_DECISION = 'CONTROLS_REVIEW_LOG_DECISION',
  CONTROL_PHASE = 'CONTROL_PHASE',
  CONTROL_TYPE = 'CONTROL_TYPE',
  CTQEDC_ENTRY = 'CTQEDC_ENTRY',
  CTQ_TYPE = 'CTQ_TYPE',
  DETECTION_TYPE = 'DETECTION_TYPE',
  RESPONSIBLE_FUNCTION = 'RESPONSIBLE_FUNCTION',
  REVIEW_LOG_DECISION = 'REVIEW_LOG_DECISION',
  RISK_CATEGORY = 'RISK_CATEGORY',
  RISK_CONTROL_STRATEGY = 'RISK_CONTROL_STRATEGY',
  RISK_LIBRARY_CATEGORY = 'RISK_LIBRARY_CATEGORY',
  RISK_OBSERVATION_CLASSIFICATION = 'RISK_OBSERVATION_CLASSIFICATION',
  RISK_QUALITY_ISSUE = 'RISK_QUALITY_ISSUE',
  SM_REVIEW_LOG_DECISION = 'SM_REVIEW_LOG_DECISION',
  /** @deprecated This is no longer in use */
  SM_REVIEW_TYPE = 'SM_REVIEW_TYPE',
  VENDOR = 'VENDOR'
}

export type NullablePartialDateTimeInput = {
  ignore?: InputMaybe<Scalars['ConvertableInt']['input']>;
  time?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NumericSeriesInput = {
  dateField: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  label: Scalars['String']['input'];
  rowData: SeriesRowDataInput;
  threshold?: InputMaybe<NumericThresholdInput>;
  type: TimelineNumericSeriesType;
  yPlotField: Scalars['String']['input'];
};

export type NumericThresholdFieldInput = {
  lower?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['String']['input']>;
};

export type NumericThresholdInput = {
  field?: InputMaybe<NumericThresholdFieldInput>;
  value?: InputMaybe<NumericThresholdValueInput>;
};

export type NumericThresholdValueInput = {
  lower?: InputMaybe<Scalars['Float']['input']>;
  upper?: InputMaybe<Scalars['Float']['input']>;
};

export type OpenCommentInput = {
  entityType: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
  replySelectors: Array<SelectorData>;
};

export type OrganisationContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationIndicationInput = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
};

export enum OrganisationMemberStatus {
  INVITED = 'INVITED',
  JOINED = 'JOINED',
  VERIFYING = 'VERIFYING'
}

export type OrganisationProductInput = {
  activeIngredients?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationProgramInput = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  indicationIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
};

export type OrganisationRoleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['ObjectId']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  rights?: InputMaybe<Array<InputMaybe<OrganisationRoleRightInput>>>;
};

export type OrganisationRoleRightInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  element?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['ConvertableInt']['input']>;
  permissions?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export type OrganisationSecurityInput = {
  accountInactiveDays?: InputMaybe<Scalars['ConvertableInt']['input']>;
  authenticationMethod?: InputMaybe<Authentication>;
  lockoutPeriodMinutes?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minLowercaseCount?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minNumberCount?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minPasswordLength?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minSpecialCharCount?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minUppercaseCount?: InputMaybe<Scalars['ConvertableInt']['input']>;
  numAttemptsBeforeLockout?: InputMaybe<Scalars['ConvertableInt']['input']>;
  ssoIssuer?: InputMaybe<Scalars['String']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  userIdleTimeoutMinutes?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export enum OrganisationType {
  CRO = 'CRO',
  NONE = 'NONE',
  SPONSOR = 'SPONSOR'
}

export enum OverviewColumnConfigurationEnumType {
  CALCULATED = 'CALCULATED',
  OVERVIEW = 'OVERVIEW',
  STATIC = 'STATIC'
}

export enum OverviewRowOrderConfigurationEnumType {
  RED_DECISION_KR_IS_DESC = 'RED_DECISION_KR_IS_DESC',
  RED_KR_IS_DESC = 'RED_KR_IS_DESC',
  SITE_NAME_ASC = 'SITE_NAME_ASC',
  SITE_NAME_DESC = 'SITE_NAME_DESC',
  SITE_SCORE_DESC = 'SITE_SCORE_DESC'
}

export enum PanelAggregate {
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN'
}

export type PanelAndDataViewInput = {
  dataViewRef?: InputMaybe<Scalars['ObjectId']['input']>;
  panelRef: Scalars['ObjectId']['input'];
};

export enum PanelAverageLineThresholdType {
  STUDY_MEDIAN_MEAN = 'STUDY_MEDIAN_MEAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum PanelBenchmark {
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum PanelColumnRangeCategory {
  DATE = 'DATE',
  NUMBER = 'NUMBER'
}

export enum PanelColumnType {
  RANGED = 'RANGED',
  STANDARD = 'STANDARD'
}

export type PanelDataSourceInput = {
  countField?: InputMaybe<Scalars['String']['input']>;
  countFirstEventTypeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  dataSource?: InputMaybe<Scalars['String']['input']>;
  dateField?: InputMaybe<Scalars['String']['input']>;
  flagField?: InputMaybe<Scalars['String']['input']>;
  rateByField?: InputMaybe<Scalars['String']['input']>;
  rateByType?: InputMaybe<PanelRateByType>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<PanelTimePeriod>;
  useEarliestEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  xAxisDataField?: InputMaybe<Scalars['String']['input']>;
  xAxisEndDateFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yAxisDataField?: InputMaybe<Scalars['String']['input']>;
};

export enum PanelDisplayBy {
  COUNTRY = 'COUNTRY',
  EVENT = 'EVENT',
  SITE = 'SITE',
  SUBJECT = 'SUBJECT'
}

export enum PanelDisplayUnits {
  COUNT = 'COUNT',
  PERCENT = 'PERCENT',
  PERCENT_BY_POPULATION = 'PERCENT_BY_POPULATION'
}

export enum PanelFieldType {
  COUNTRY_SITE_MEAN = 'COUNTRY_SITE_MEAN',
  SITE_RATE = 'SITE_RATE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SITE_MEAN = 'STUDY_SITE_MEAN'
}

export enum PanelGraphCategoryClause {
  EQUAL = 'EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
  MORE_THAN = 'MORE_THAN',
  MORE_THAN_EQUAL = 'MORE_THAN_EQUAL',
  NONE = 'NONE'
}

export type PanelGraphCategoryInput = {
  clause?: InputMaybe<PanelGraphCategoryClause>;
  index: Scalars['ConvertableInt']['input'];
  max?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  min?: InputMaybe<Scalars['ConvertableFloat']['input']>;
};

export type PanelGraphInput = {
  categories?: InputMaybe<Array<InputMaybe<PanelGraphCategoryInput>>>;
  categoryRangePeriod?: InputMaybe<PanelTimePeriod>;
  categoryRangeUnit?: InputMaybe<Scalars['ConvertableInt']['input']>;
  columnRangeCategory?: InputMaybe<PanelColumnRangeCategory>;
  columnType?: InputMaybe<PanelColumnType>;
  dataInclusionPeriod?: InputMaybe<PanelTimePeriod>;
  dataInclusionUnit?: InputMaybe<Scalars['ConvertableInt']['input']>;
  displayBy?: InputMaybe<PanelDisplayBy>;
  displayUnits?: InputMaybe<PanelDisplayUnits>;
  hideStudyColumns?: InputMaybe<Scalars['Boolean']['input']>;
  lineCalculation?: InputMaybe<PanelLineCalculation>;
  lineThresholdType?: InputMaybe<PanelAverageLineThresholdType>;
  numberOfSeries?: InputMaybe<Scalars['ConvertableInt']['input']>;
  orderBy?: InputMaybe<PanelOrderBy>;
  plotThreshold?: InputMaybe<Scalars['ConvertableInt']['input']>;
  plotTitle?: InputMaybe<Scalars['String']['input']>;
  series?: InputMaybe<Array<InputMaybe<PanelGraphSeriesInput>>>;
  seriesType?: InputMaybe<PanelSeriesType>;
  thresholdNum1?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  thresholdNum2?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  timePeriod?: InputMaybe<PanelLineTimePeriod>;
  type?: InputMaybe<PanelGraphType>;
  xTitle?: InputMaybe<Scalars['String']['input']>;
  yTitle?: InputMaybe<Scalars['String']['input']>;
};

export type PanelGraphSeriesInput = {
  dataPointField?: InputMaybe<Scalars['String']['input']>;
  dataSource?: InputMaybe<Scalars['String']['input']>;
  dateField?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export enum PanelGraphType {
  COLUMN = 'COLUMN',
  DONUT = 'DONUT',
  HEATMAP = 'HEATMAP',
  RADIAL = 'RADIAL',
  SANKEY = 'SANKEY',
  SCATTER_PLOT_LINE = 'SCATTER_PLOT_LINE',
  STACKED_COLUMN = 'STACKED_COLUMN'
}

export type PanelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  associatedRisks?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  dataSource?: InputMaybe<PanelDataSourceInput>;
  decision?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventRatesOverTimeParameters?: InputMaybe<EventRatesOverTimeInput>;
  graph?: InputMaybe<PanelGraphInput>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  includeInSiteScoring?: InputMaybe<Scalars['Boolean']['input']>;
  modelParams?: InputMaybe<PanelModelParamsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['ObjectId']['input']>;
  panelTheme?: InputMaybe<PanelTheme>;
  panelType?: InputMaybe<PanelType>;
  proportionsOverTimeParameters?: InputMaybe<ProportionsOverTimeInput>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  scheduleId?: InputMaybe<Scalars['ObjectId']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  studyOverviewExtraColumns?: InputMaybe<Array<InputMaybe<StudyOverviewExtraColumnInput>>>;
  timeline?: InputMaybe<TimelineInput>;
  triOpDateParameters?: InputMaybe<TriOpDateParametersInput>;
  weight?: InputMaybe<Scalars['ConvertableInt']['input']>;
  yAxisColumnValue?: InputMaybe<Scalars['String']['input']>;
};

export enum PanelIntervalType {
  APPROXIMATE = 'APPROXIMATE',
  EXACT = 'EXACT'
}

export enum PanelLineCalculation {
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN'
}

export enum PanelLineTimePeriod {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export type PanelModelParamsInput = {
  amberCutoff?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  amberMaxScore?: InputMaybe<Scalars['ConvertableInt']['input']>;
  benchmarkType?: InputMaybe<PanelBenchmark>;
  benchmarkValue?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  confidenceIntervalType?: InputMaybe<PanelIntervalType>;
  dataInclusionPeriod?: InputMaybe<PanelTimePeriod>;
  dataInclusionUnit?: InputMaybe<Scalars['ConvertableInt']['input']>;
  greenMaxScore?: InputMaybe<Scalars['ConvertableInt']['input']>;
  hideLower?: InputMaybe<Scalars['Boolean']['input']>;
  hideUpper?: InputMaybe<Scalars['Boolean']['input']>;
  lowerAmber?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  lowerBigRed?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  lowerRed?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  minimumDataMovementScore?: InputMaybe<Scalars['ConvertableInt']['input']>;
  plotBy?: InputMaybe<PanelPlotBy>;
  rateBy?: InputMaybe<PanelRateBy>;
  rateGroupType?: InputMaybe<RateGroupType>;
  redCutoff?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  siteScoring?: InputMaybe<PanelSiteScoring>;
  stableValue?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  stableVariableType?: InputMaybe<Scalars['String']['input']>;
  studyComparison?: InputMaybe<PanelAggregate>;
  thresholdNum1?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  thresholdNum2?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  triThreshold1Type?: InputMaybe<PanelThresholdType>;
  triThreshold2Type?: InputMaybe<PanelThresholdType>;
  type?: InputMaybe<PanelModelType>;
  unitMultiplier?: InputMaybe<Scalars['ConvertableInt']['input']>;
  upperAmber?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  upperBigRed?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  upperRed?: InputMaybe<Scalars['ConvertableFloat']['input']>;
};

export enum PanelModelType {
  FUNNEL = 'FUNNEL',
  FUNNEL_TREND = 'FUNNEL_TREND',
  RATE_GROUP = 'RATE_GROUP',
  RATE_GROUP_TREND = 'RATE_GROUP_TREND',
  TRI_OPERATIONAL = 'TRI_OPERATIONAL',
  TRI_OPERATIONAL_TREND = 'TRI_OPERATIONAL_TREND'
}

export enum PanelOrderBy {
  LABEL_ASCENDING = 'LABEL_ASCENDING',
  LABEL_DESCENDING = 'LABEL_DESCENDING',
  LABEL_VISIT_SEQUENCE_NUMBER = 'LABEL_VISIT_SEQUENCE_NUMBER',
  VOLUME_ASCENDING = 'VOLUME_ASCENDING',
  VOLUME_BELL_CURVE = 'VOLUME_BELL_CURVE',
  VOLUME_DESCENDING = 'VOLUME_DESCENDING'
}

export enum PanelPlotBy {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS'
}

export enum PanelRateBy {
  MONTHS = 'MONTHS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum PanelRateByType {
  COUNT = 'COUNT',
  TIME_PERIOD = 'TIME_PERIOD'
}

export enum PanelSeriesType {
  EVENT = 'EVENT',
  SITE = 'SITE',
  SITE_AVERAGE = 'SITE_AVERAGE',
  SITE_CUMULATIVE = 'SITE_CUMULATIVE',
  SUBJECT = 'SUBJECT',
  SUBJECT_BY_VISIT = 'SUBJECT_BY_VISIT'
}

export enum PanelSiteScoring {
  HIGHER_GREEN = 'HIGHER_GREEN',
  HIGHER_PURPLE = 'HIGHER_PURPLE',
  LOWER_GREEN = 'LOWER_GREEN',
  LOWER_PURPLE = 'LOWER_PURPLE',
  STANDARD = 'STANDARD'
}

export enum PanelTheme {
  NONE = 'NONE',
  THEME_1 = 'THEME_1',
  THEME_2 = 'THEME_2',
  THEME_3 = 'THEME_3',
  THEME_4 = 'THEME_4'
}

export enum PanelThresholdType {
  SAMPLE_MEAN = 'SAMPLE_MEAN',
  SAMPLE_MEDIAN = 'SAMPLE_MEDIAN',
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum PanelTimePeriod {
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  QUARTERS = 'QUARTERS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum PanelType {
  EVENT_RATES_OVER_TIME = 'EVENT_RATES_OVER_TIME',
  GRAPH = 'GRAPH',
  MODEL = 'MODEL',
  PROPORTIONS_OVER_TIME = 'PROPORTIONS_OVER_TIME',
  TIMELINE = 'TIMELINE',
  TRI_OP_DATE = 'TRI_OP_DATE'
}

export enum PhaseType {
  DETECTION = 'DETECTION',
  PRE_STUDY = 'PRE_STUDY',
  RESULTS_REPORTING = 'RESULTS_REPORTING',
  STUDY_CONDUCT = 'STUDY_CONDUCT'
}

export enum ProportionsOTBenchmarkType {
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SITE_MEAN = 'STUDY_SITE_MEAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum ProportionsOTCountryBenchmarkType {
  COUNTRY_RATE = 'COUNTRY_RATE',
  COUNTRY_SITE_MEAN = 'COUNTRY_SITE_MEAN',
  NONE = 'NONE',
  STUDY_RATE = 'STUDY_RATE',
  STUDY_SITE_MEAN = 'STUDY_SITE_MEAN',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum ProportionsOTThresholdType {
  FIXED = 'FIXED',
  LANEY_P_CHART = 'LANEY_P_CHART',
  P_CHART = 'P_CHART',
  QUASI_BINOMIAL_P_CHART = 'QUASI_BINOMIAL_P_CHART'
}

export type ProportionsOverTimeInput = {
  automationRange?: InputMaybe<AutomationRange>;
  benchmarkType?: InputMaybe<ProportionsOTBenchmarkType>;
  countryBenchmark?: InputMaybe<ProportionsOTCountryBenchmarkType>;
  cumulativeOrTimePeriod?: InputMaybe<ModelPlotCalculation>;
  denominatorName?: InputMaybe<Scalars['String']['input']>;
  eligibilityPeriod?: InputMaybe<ControlHubModelPeriodType>;
  eligibilityUnit?: InputMaybe<Scalars['Int']['input']>;
  expectedVolume?: InputMaybe<Scalars['Int']['input']>;
  lowerAmber?: InputMaybe<Scalars['Float']['input']>;
  lowerRed?: InputMaybe<Scalars['Float']['input']>;
  minData?: InputMaybe<Scalars['Int']['input']>;
  numberOfTimePeriods?: InputMaybe<Scalars['Int']['input']>;
  numeratorName?: InputMaybe<Scalars['String']['input']>;
  plotBy?: InputMaybe<ModelPlotBy>;
  qtl?: InputMaybe<Scalars['Boolean']['input']>;
  reportOutOfTolerance?: InputMaybe<Scalars['Boolean']['input']>;
  rowData?: InputMaybe<Scalars['String']['input']>;
  rowDataDate?: InputMaybe<Scalars['String']['input']>;
  rowDataFlag?: InputMaybe<Scalars['String']['input']>;
  scaleBy?: InputMaybe<ModelScaleBy>;
  studySpecificBenchmark?: InputMaybe<Scalars['Float']['input']>;
  thresholdType?: InputMaybe<ProportionsOTThresholdType>;
  upperAmber?: InputMaybe<Scalars['Float']['input']>;
  upperRed?: InputMaybe<Scalars['Float']['input']>;
  xAxisPtsToShade?: InputMaybe<Scalars['Int']['input']>;
  xAxisTitle?: InputMaybe<Scalars['String']['input']>;
  yAxisTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ProtocolDocumentInput = {
  documentName?: InputMaybe<Scalars['String']['input']>;
  riqId?: InputMaybe<Scalars['Guid']['input']>;
  status?: InputMaybe<ProtocolDocumentStatus>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** The current status of a protocol document */
export enum ProtocolDocumentStatus {
  DISCARDED = 'DISCARDED',
  IN_REVIEW = 'IN_REVIEW',
  PROCESSING = 'PROCESSING',
  REVIEW_COMPLETED = 'REVIEW_COMPLETED'
}

export enum RAGColourType {
  AMBER = 'AMBER',
  GREEN = 'GREEN',
  RED = 'RED'
}

export type RAGInput = {
  colour?: InputMaybe<RAGColourType>;
  x?: InputMaybe<Scalars['ConvertableInt']['input']>;
  y?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export enum RateGroupType {
  NEGATIVE_BINOMIAL = 'NEGATIVE_BINOMIAL',
  POISSON = 'POISSON'
}

export type ReportDefinitionColumnInput = {
  dataField?: InputMaybe<ReportDefinitionFieldTypes>;
  index?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export enum ReportDefinitionFieldTypes {
  ACT_COMMENTS = 'ACT_COMMENTS',
  ACT_COMPLETED_DATE = 'ACT_COMPLETED_DATE',
  ACT_DESCRIPTION = 'ACT_DESCRIPTION',
  ACT_EXPECTED_COMPLETION_DATE = 'ACT_EXPECTED_COMPLETION_DATE',
  ACT_ID = 'ACT_ID',
  ACT_OBS = 'ACT_OBS',
  ACT_OBS_ID = 'ACT_OBS_ID',
  ACT_OWNER = 'ACT_OWNER',
  ACT_REQUESTED_DATE = 'ACT_REQUESTED_DATE',
  ACT_RESPONSIBLE_FUNCTION = 'ACT_RESPONSIBLE_FUNCTION',
  ACT_RESULT = 'ACT_RESULT',
  ACT_TYPE = 'ACT_TYPE',
  CM_CONTROLS_HUB_CHART_ASSOCIATED_RISKS = 'CM_CONTROLS_HUB_CHART_ASSOCIATED_RISKS',
  CM_CONTROLS_HUB_CHART_BENCHMARK = 'CM_CONTROLS_HUB_CHART_BENCHMARK',
  CM_CONTROLS_HUB_CHART_DATASET = 'CM_CONTROLS_HUB_CHART_DATASET',
  CM_CONTROLS_HUB_CHART_LOWER_AMBER = 'CM_CONTROLS_HUB_CHART_LOWER_AMBER',
  CM_CONTROLS_HUB_CHART_LOWER_RED = 'CM_CONTROLS_HUB_CHART_LOWER_RED',
  CM_CONTROLS_HUB_CHART_OOT_VALUE = 'CM_CONTROLS_HUB_CHART_OOT_VALUE',
  CM_CONTROLS_HUB_CHART_PLOT_TITLE = 'CM_CONTROLS_HUB_CHART_PLOT_TITLE',
  CM_CONTROLS_HUB_CHART_STATUS = 'CM_CONTROLS_HUB_CHART_STATUS',
  CM_CONTROLS_HUB_CHART_TIME_PERIOD = 'CM_CONTROLS_HUB_CHART_TIME_PERIOD',
  CM_CONTROLS_HUB_CHART_UPPER_AMBER = 'CM_CONTROLS_HUB_CHART_UPPER_AMBER',
  CM_CONTROLS_HUB_CHART_UPPER_RED = 'CM_CONTROLS_HUB_CHART_UPPER_RED',
  CM_CONTROLS_HUB_CHART_Y_AXIS_LABEL = 'CM_CONTROLS_HUB_CHART_Y_AXIS_LABEL',
  CONT_ACTION_TO_BE_TAKEN = 'CONT_ACTION_TO_BE_TAKEN',
  CONT_ACTIVE_DATE = 'CONT_ACTIVE_DATE',
  CONT_ADDITIONAL_INFORMATION = 'CONT_ADDITIONAL_INFORMATION',
  CONT_DATE_IDENTIFIED = 'CONT_DATE_IDENTIFIED',
  CONT_DESCRIPTION = 'CONT_DESCRIPTION',
  CONT_ID = 'CONT_ID',
  CONT_INACTIVATE_DATE = 'CONT_INACTIVATE_DATE',
  CONT_MONITORING_PURPOSE = 'CONT_MONITORING_PURPOSE',
  CONT_MONITORING_VOLUME = 'CONT_MONITORING_VOLUME',
  CONT_OWNER = 'CONT_OWNER',
  CONT_PHASE = 'CONT_PHASE',
  CONT_RESPONSIBLE_FUNCTION = 'CONT_RESPONSIBLE_FUNCTION',
  CONT_REVIEW_FREQUENCY_PERIOD = 'CONT_REVIEW_FREQUENCY_PERIOD',
  CONT_REVIEW_FREQUENCY_UNITS = 'CONT_REVIEW_FREQUENCY_UNITS',
  CONT_THRESHOLD = 'CONT_THRESHOLD',
  CONT_TYPE = 'CONT_TYPE',
  CVEDC_ENTRY = 'CVEDC_ENTRY',
  CVFDR_COUNT = 'CVFDR_COUNT',
  CVID = 'CVID',
  CVISMP = 'CVISMP',
  CV_ACTIVE = 'CV_ACTIVE',
  CV_CRITICAL = 'CV_CRITICAL',
  CV_DATA_SOURCE = 'CV_DATA_SOURCE',
  CV_DESCRIPTION = 'CV_DESCRIPTION',
  CV_JUSTIFICATION = 'CV_JUSTIFICATION',
  CV_OPEN_COMMENTS_COUNT = 'CV_OPEN_COMMENTS_COUNT',
  CV_RESPONSIBLE_VENDOR = 'CV_RESPONSIBLE_VENDOR',
  CV_RISK_COUNT = 'CV_RISK_COUNT',
  CV_SYSTEM = 'CV_SYSTEM',
  CV_TYPE = 'CV_TYPE',
  FDR_COMMENT = 'FDR_COMMENT',
  FDR_DESCRIPTION = 'FDR_DESCRIPTION',
  FDR_ID = 'FDR_ID',
  FDR_RESPONSIBLE_FUNCTION = 'FDR_RESPONSIBLE_FUNCTION',
  OBS_CLASSIFICATION = 'OBS_CLASSIFICATION',
  OBS_CLOSED_DATE = 'OBS_CLOSED_DATE',
  OBS_COMMENTS = 'OBS_COMMENTS',
  OBS_CONFIRMED_CAUSE = 'OBS_CONFIRMED_CAUSE',
  OBS_COUNTRIES = 'OBS_COUNTRIES',
  OBS_ID = 'OBS_ID',
  OBS_OBSERVATION = 'OBS_OBSERVATION',
  OBS_OBSERVATION_DATE = 'OBS_OBSERVATION_DATE',
  OBS_OWNER = 'OBS_OWNER',
  OBS_POTENTIAL_CAUSE = 'OBS_POTENTIAL_CAUSE',
  OBS_RESOLUTION = 'OBS_RESOLUTION',
  OBS_RESPONSIBLE_FUNCTION = 'OBS_RESPONSIBLE_FUNCTION',
  OBS_RISK_ID = 'OBS_RISK_ID',
  OBS_RISK_STATEMENT = 'OBS_RISK_STATEMENT',
  OBS_VENDORS = 'OBS_VENDORS',
  RISK_CATEGORY = 'RISK_CATEGORY',
  RISK_CLOSED_DATE = 'RISK_CLOSED_DATE',
  RISK_CONTROL_STRATEGY = 'RISK_CONTROL_STRATEGY',
  RISK_COUNTRIES = 'RISK_COUNTRIES',
  RISK_DATE_IDENTIFIED = 'RISK_DATE_IDENTIFIED',
  RISK_DETECTABILITY = 'RISK_DETECTABILITY',
  RISK_ID = 'RISK_ID',
  RISK_IMPACT = 'RISK_IMPACT',
  RISK_INTERNAL = 'RISK_INTERNAL',
  RISK_JUSTIFICATION = 'RISK_JUSTIFICATION',
  RISK_LAST_REVIEW_DATE = 'RISK_LAST_REVIEW_DATE',
  RISK_LIKELIHOOD = 'RISK_LIKELIHOOD',
  RISK_LINKED_CM_CONTROLS_COUNT = 'RISK_LINKED_CM_CONTROLS_COUNT',
  RISK_NEXT_REVIEW_DATE = 'RISK_NEXT_REVIEW_DATE',
  RISK_OPEN_COMMENTS_COUNT = 'RISK_OPEN_COMMENTS_COUNT',
  RISK_OUT_OF_TOLERANCE = 'RISK_OUT_OF_TOLERANCE',
  RISK_OWNER = 'RISK_OWNER',
  RISK_QUALITY_ISSUE = 'RISK_QUALITY_ISSUE',
  RISK_QUALITY_ISSUE_REFERENCE = 'RISK_QUALITY_ISSUE_REFERENCE',
  RISK_RAG = 'RISK_RAG',
  RISK_RATIONALE = 'RISK_RATIONALE',
  RISK_RESPONSIBLE_FUNCTION = 'RISK_RESPONSIBLE_FUNCTION',
  RISK_REVIEW_FREQUENCY_PERIOD = 'RISK_REVIEW_FREQUENCY_PERIOD',
  RISK_REVIEW_FREQUENCY_UNIT = 'RISK_REVIEW_FREQUENCY_UNIT',
  RISK_REVIEW_REQUIRED = 'RISK_REVIEW_REQUIRED',
  RISK_REVIEW_STATUS = 'RISK_REVIEW_STATUS',
  RISK_SCORE = 'RISK_SCORE',
  RISK_STATEMENT = 'RISK_STATEMENT',
  RISK_STATUS = 'RISK_STATUS',
  RISK_VENDORS = 'RISK_VENDORS'
}

export type ReportDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  includeDraftRisks?: InputMaybe<Scalars['Boolean']['input']>;
  includeInternalRisks?: InputMaybe<Scalars['Boolean']['input']>;
  includeNotApplicableRisks?: InputMaybe<Scalars['Boolean']['input']>;
  includeObsoleteRisks?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  tabs?: InputMaybe<Array<InputMaybe<ReportDefinitionTabInput>>>;
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type ReportDefinitionTabInput = {
  columns?: InputMaybe<Array<InputMaybe<ReportDefinitionColumnInput>>>;
  tabType?: InputMaybe<ReportDefinitionTabs>;
};

export enum ReportDefinitionTabs {
  ACTIONS = 'ACTIONS',
  CONTROLS = 'CONTROLS',
  CRITICAL_VARIABLES = 'CRITICAL_VARIABLES',
  CRITICAL_VARIABLES_AND_CONTROLS = 'CRITICAL_VARIABLES_AND_CONTROLS',
  CRITICAL_VARIABLES_AND_FUNCTIONAL_DATA_REVIEWS = 'CRITICAL_VARIABLES_AND_FUNCTIONAL_DATA_REVIEWS',
  FUNCTIONAL_DATA_REVIEWS = 'FUNCTIONAL_DATA_REVIEWS',
  OBSERVATIONS = 'OBSERVATIONS',
  OBSERVATIONS_AND_ACTIONS = 'OBSERVATIONS_AND_ACTIONS',
  RISKS = 'RISKS',
  RISKS_AND_CM_CONTROL_HUB_CHARTS = 'RISKS_AND_CM_CONTROL_HUB_CHARTS',
  RISKS_AND_CONTROLS = 'RISKS_AND_CONTROLS',
  RISKS_AND_CRITICAL_VARIABLES = 'RISKS_AND_CRITICAL_VARIABLES'
}

export type ReportSignatoryInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  role?: InputMaybe<ReportSignatoryRole>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportSignatoryRole {
  APPROVER = 'APPROVER',
  AUTHOR = 'AUTHOR',
  REVIEWER = 'REVIEWER'
}

export enum ReportStatus {
  FINAL = 'FINAL',
  OBSOLETE = 'OBSOLETE',
  PREVIEW = 'PREVIEW'
}

export enum RiqStatusType {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_AND_PROMOTED = 'ACCEPTED_AND_PROMOTED',
  IMPORTED = 'IMPORTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type RiskActionInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedCompleteDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectId']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  requestDate?: InputMaybe<Scalars['Date']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RiskActionType>;
};

export enum RiskActionType {
  CORRECTIVE = 'CORRECTIVE',
  NONE = 'NONE',
  PREVENTATIVE = 'PREVENTATIVE'
}

export type RiskAssessmentTagInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type RiskDashboardConfigInput = {
  organisationId?: InputMaybe<Scalars['ObjectId']['input']>;
  panels?: InputMaybe<Array<InputMaybe<RiskDashboardPanelDataInput>>>;
};

export enum RiskDashboardPanel {
  RISK_CATEGORIES = 'RISK_CATEGORIES',
  RISK_MAP = 'RISK_MAP',
  RISK_REVIEW_STATUS = 'RISK_REVIEW_STATUS',
  STUDY_RISK_TRENDS = 'STUDY_RISK_TRENDS'
}

export type RiskDashboardPanelDataInput = {
  displayOrder?: InputMaybe<Scalars['ConvertableInt']['input']>;
  panelId?: InputMaybe<RiskDashboardPanel>;
};

export enum RiskEvaluationColor {
  AMBER = 'AMBER',
  GREEN = 'GREEN',
  NONE = 'NONE',
  RED = 'RED'
}

export type RiskEvaluationInput = {
  changeReason?: InputMaybe<Scalars['String']['input']>;
  detectability?: InputMaybe<Scalars['ConvertableInt']['input']>;
  evaluationModelId?: InputMaybe<Scalars['ObjectId']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  impact?: InputMaybe<Scalars['ConvertableInt']['input']>;
  likelihood?: InputMaybe<Scalars['ConvertableInt']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  type?: InputMaybe<RiskEvaluationType>;
};

export type RiskEvaluationModelInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  detectability?: InputMaybe<Array<InputMaybe<RiskEvaluationModelItemInput>>>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  impact?: InputMaybe<Array<InputMaybe<RiskEvaluationModelItemInput>>>;
  includeDetectability?: InputMaybe<Scalars['Boolean']['input']>;
  likelihood?: InputMaybe<Array<InputMaybe<RiskEvaluationModelItemInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ragMap?: InputMaybe<Array<InputMaybe<RAGInput>>>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  reviewPeriodDays?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export type RiskEvaluationModelItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['ConvertableInt']['input']>;
};

export enum RiskEvaluationScoreTrendType {
  FALLING = 'FALLING',
  NO_MOVEMENT = 'NO_MOVEMENT',
  NO_TREND = 'NO_TREND',
  RISING = 'RISING',
  STABLE = 'STABLE'
}

export enum RiskEvaluationType {
  ORIGINAL = 'ORIGINAL',
  RESCORE = 'RESCORE'
}

export type RiskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ObjectId']['input']>;
  closedDate?: InputMaybe<Scalars['Date']['input']>;
  controlStrategyId?: InputMaybe<Scalars['ObjectId']['input']>;
  controls?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  countries?: InputMaybe<Array<InputMaybe<CountryInputType>>>;
  dateIdentified?: InputMaybe<Scalars['Date']['input']>;
  dateLastReviewed?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  libraryReferenceId?: InputMaybe<Scalars['ObjectId']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectId']['input']>;
  qualityIssueId?: InputMaybe<Scalars['ObjectId']['input']>;
  qualityIssueReference?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
  reviewFrequencyPeriod?: InputMaybe<Scalars['ConvertableInt']['input']>;
  reviewFrequencyUnits?: InputMaybe<TimeFrequencyType>;
  reviewRequired?: InputMaybe<Scalars['Boolean']['input']>;
  riqRejectionReason?: InputMaybe<Scalars['String']['input']>;
  riqSourceExcerpt?: InputMaybe<Scalars['String']['input']>;
  riqSourcePageNumber?: InputMaybe<Scalars['Int']['input']>;
  riqStatus?: InputMaybe<RiqStatusType>;
  statement?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RiskStatusType>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type RiskObservationInput = {
  classificationId?: InputMaybe<Scalars['ObjectId']['input']>;
  closedDate?: InputMaybe<Scalars['Date']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  confirmedCause?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryInputType>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  observationDate?: InputMaybe<Scalars['Date']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectId']['input']>;
  potentialCause?: InputMaybe<Scalars['String']['input']>;
  qtlExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
  riskId?: InputMaybe<Scalars['ObjectId']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
};

export type RiskPocCommentInput = {
  /** The ID of this comment. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the risk this comment is associated with. */
  parentId: Scalars['String']['input'];
  /** The ID of the publisher of this comment. */
  publisherUserId: Scalars['String']['input'];
};

export enum RiskReviewStatusType {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_REVIEWED = 'NOT_REVIEWED',
  REVIEWED = 'REVIEWED',
  REVIEW_DUE = 'REVIEW_DUE',
  REVIEW_NOT_REQUIRED = 'REVIEW_NOT_REQUIRED',
  REVIEW_OVERDUE = 'REVIEW_OVERDUE'
}

export enum RiskStatusType {
  ASSESSED = 'ASSESSED',
  CLOSED = 'CLOSED',
  CONTROLLED = 'CONTROLLED',
  DRAFT = 'DRAFT',
  IDENTIFIED = 'IDENTIFIED',
  /** Not Applicable */
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  OBSOLETE = 'OBSOLETE',
  TRIGGERED = 'TRIGGERED'
}

export enum RowDataSourceTable {
  NONE = 'NONE',
  SITE = 'SITE',
  SITE_ISSUE = 'SITE_ISSUE',
  SITE_PROTOCOL_DEVIATION = 'SITE_PROTOCOL_DEVIATION',
  SITE_VISIT = 'SITE_VISIT',
  STUDY = 'STUDY',
  SUBJECT = 'SUBJECT',
  SUBJECT_ADVERSE_EVENT = 'SUBJECT_ADVERSE_EVENT',
  SUBJECT_ASSESSMENT = 'SUBJECT_ASSESSMENT',
  SUBJECT_CONCOMITANT_MEDICATION = 'SUBJECT_CONCOMITANT_MEDICATION',
  SUBJECT_CRF = 'SUBJECT_CRF',
  SUBJECT_INFORMED_CONSENT = 'SUBJECT_INFORMED_CONSENT',
  SUBJECT_ISSUE = 'SUBJECT_ISSUE',
  SUBJECT_LAB = 'SUBJECT_LAB',
  SUBJECT_MEDICAL_HISTORY = 'SUBJECT_MEDICAL_HISTORY',
  SUBJECT_PROTOCOL_DEVIATION = 'SUBJECT_PROTOCOL_DEVIATION',
  SUBJECT_QUERY = 'SUBJECT_QUERY',
  SUBJECT_VISIT = 'SUBJECT_VISIT'
}

export enum RowDataSourceTag {
  DATA_TABLE = 'DATA_TABLE',
  DATA_TABLE_DATA_LISTING = 'DATA_TABLE_DATA_LISTING',
  DATA_TABLE_SITE_SUMMARY = 'DATA_TABLE_SITE_SUMMARY',
  DATA_TABLE_SUBJECT_SUMMARY = 'DATA_TABLE_SUBJECT_SUMMARY',
  PANEL = 'PANEL',
  SITE_LISTING = 'SITE_LISTING'
}

export enum RuleClauseEnumType {
  AND = 'AND',
  NONE = 'NONE',
  OR = 'OR'
}

export enum RuleClauseOperatorEnumType {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_EQUALS = 'GREATER_THAN_EQUALS',
  IN = 'IN',
  IS_BLANK = 'IS_BLANK',
  IS_NOT_BLANK = 'IS_NOT_BLANK',
  IS_NOT_NULL = 'IS_NOT_NULL',
  IS_NULL = 'IS_NULL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_EQUALS = 'LESS_THAN_EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  NOT_IN = 'NOT_IN'
}

export type RuleInput = {
  comparatorField?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  ruleClause?: InputMaybe<RuleClauseEnumType>;
  ruleClauseOperator?: InputMaybe<RuleClauseOperatorEnumType>;
  value?: InputMaybe<Scalars['_Any']['input']>;
};

export enum ScoreColourType {
  AMBER = 'AMBER',
  GREEN = 'GREEN',
  GREY = 'GREY',
  NONE = 'NONE',
  PURPLE = 'PURPLE',
  RED = 'RED'
}

export type SelectorData = {
  id: Scalars['ObjectId']['input'];
  version: Scalars['Int']['input'];
};

export type SeriesRowDataInput = {
  rule?: InputMaybe<TimelineRuleInput>;
  source: Scalars['String']['input'];
};

export enum SiteAverage {
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN'
}

export type SmStudyMemberInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultSiteId?: InputMaybe<Scalars['ObjectId']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  favourite?: InputMaybe<Scalars['Boolean']['input']>;
  favouriteSiteIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  status?: InputMaybe<StudyMemberStatus>;
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum StableVariableType {
  NUMBER = 'NUMBER',
  PERCENTAGE = 'PERCENTAGE'
}

export type StudyAssessmentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentRules?: InputMaybe<Array<InputMaybe<RuleInput>>>;
  completedFieldName?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  crfId?: InputMaybe<Scalars['ObjectId']['input']>;
  endPoint?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  lab?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  safety?: InputMaybe<Scalars['Boolean']['input']>;
  sendToVendor?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StudyAutomationColor {
  NONE = 'NONE',
  RED_AMBER = 'RED_AMBER',
  RED_AMBER_PURPLE = 'RED_AMBER_PURPLE',
  RED_ONLY = 'RED_ONLY',
  RED_PURPLE = 'RED_PURPLE'
}

export type StudyCohortInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  subjectCode?: InputMaybe<Scalars['String']['input']>;
};

export enum StudyConfigurationImportType {
  ASSESSMENTS = 'ASSESSMENTS',
  COHORTS = 'COHORTS',
  CONTROLS_HUB_CONFIG_PANEL = 'CONTROLS_HUB_CONFIG_PANEL',
  CONTROLS_HUB_CONFIG_WIDGET = 'CONTROLS_HUB_CONFIG_WIDGET',
  CONTROLS_HUB_WIDGETS = 'CONTROLS_HUB_WIDGETS',
  CR_FS = 'CR_FS',
  DASHBOARDS = 'DASHBOARDS',
  DASHBOARD_WIDGET = 'DASHBOARD_WIDGET',
  DATA_FILTERS = 'DATA_FILTERS',
  DATA_LISTINGS_CONFIGURATION = 'DATA_LISTINGS_CONFIGURATION',
  DATA_LISTING_CONFIGURATION = 'DATA_LISTING_CONFIGURATION',
  DATA_TABLES = 'DATA_TABLES',
  DATA_VIEW_CONFIGURATION = 'DATA_VIEW_CONFIGURATION',
  EXTRA_DATA_FIELDS = 'EXTRA_DATA_FIELDS',
  PANELS = 'PANELS',
  SITE_DATA_FILTERS = 'SITE_DATA_FILTERS',
  STUDIES = 'STUDIES',
  STUDY_DASHBOARD_CONFIG = 'STUDY_DASHBOARD_CONFIG',
  STUDY_DASHBOARD_CONFIG_PANEL = 'STUDY_DASHBOARD_CONFIG_PANEL',
  STUDY_HUB_SITE_FIELDS_CONFIG = 'STUDY_HUB_SITE_FIELDS_CONFIG',
  STUDY_HUB_STUDY_FIELDS_CONFIG = 'STUDY_HUB_STUDY_FIELDS_CONFIG',
  STUDY_VISIT = 'STUDY_VISIT',
  SUBJECT_DATA_FILTERS = 'SUBJECT_DATA_FILTERS',
  SUBJECT_HUB_OVERVIEW_GRID_CONFIGURATION = 'SUBJECT_HUB_OVERVIEW_GRID_CONFIGURATION',
  SUBJECT_PROFILE_DETAILS_CONFIGURATION = 'SUBJECT_PROFILE_DETAILS_CONFIGURATION',
  SV_TS = 'SV_TS',
  TREATMENT_ARMS = 'TREATMENT_ARMS',
  WIDGETS = 'WIDGETS'
}

export type StudyControlInput = {
  actionToBeTaken?: InputMaybe<Scalars['String']['input']>;
  activeDate?: InputMaybe<Scalars['Date']['input']>;
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  controlPhaseId?: InputMaybe<Scalars['ObjectId']['input']>;
  dateIdentified?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  inactiveDate?: InputMaybe<Scalars['Date']['input']>;
  libraryControlId?: InputMaybe<Scalars['ObjectId']['input']>;
  ownerId?: InputMaybe<Scalars['ObjectId']['input']>;
  phase?: InputMaybe<PhaseType>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  responsibleFunctionId?: InputMaybe<Scalars['ObjectId']['input']>;
  reviewFrequencyPeriod?: InputMaybe<Scalars['ConvertableInt']['input']>;
  reviewFrequencyUnits?: InputMaybe<TimeFrequencyType>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  threshold?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ObjectId']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
};

export type StudyCrfInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  crfName?: InputMaybe<Scalars['String']['input']>;
  crfRules?: InputMaybe<Array<InputMaybe<RuleInput>>>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  subjectCode?: InputMaybe<Scalars['String']['input']>;
};

export type StudyDashboardConfigWidgetInputType = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  recordId?: InputMaybe<Scalars['Long']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  tableCode?: InputMaybe<Scalars['Int']['input']>;
  typeCode?: InputMaybe<Scalars['Int']['input']>;
  useOnSiteGrid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudyDashboardConfigurationInput = {
  dataSetFilter?: InputMaybe<Scalars['Int']['input']>;
  dataSetsCount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type StudyHubMonitoringToolkitConfigInput = {
  allowKRIReviews?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type StudyHubPanelLineSelectorConfigInput = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  studyRate?: InputMaybe<Scalars['Boolean']['input']>;
  studySiteMean?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudyHubSiteFieldsConfigInput = {
  activeDate?: InputMaybe<Scalars['Boolean']['input']>;
  closedDate?: InputMaybe<Scalars['Boolean']['input']>;
  investigator?: InputMaybe<Scalars['Boolean']['input']>;
  monitor?: InputMaybe<Scalars['Boolean']['input']>;
  numAmberDecisionMakingKRIs?: InputMaybe<Scalars['Boolean']['input']>;
  numAmberKRIs?: InputMaybe<Scalars['Boolean']['input']>;
  numGreenDecisionMakingKRIs?: InputMaybe<Scalars['Boolean']['input']>;
  numGreenKRIs?: InputMaybe<Scalars['Boolean']['input']>;
  numRedDecisionMakingKRIs?: InputMaybe<Scalars['Boolean']['input']>;
  numRedKRIs?: InputMaybe<Scalars['Boolean']['input']>;
  score?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudyHubStudyFieldsConfigInput = {
  countrySiteMean?: InputMaybe<Scalars['Boolean']['input']>;
  numAmberSites?: InputMaybe<Scalars['Boolean']['input']>;
  numGreenSites?: InputMaybe<Scalars['Boolean']['input']>;
  numRedSites?: InputMaybe<Scalars['Boolean']['input']>;
  siteRate?: InputMaybe<Scalars['Boolean']['input']>;
  studyRate?: InputMaybe<Scalars['Boolean']['input']>;
  studySiteMean?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudyInput = {
  adjustmentWeight?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  assessmentAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  automationActive?: InputMaybe<Scalars['Boolean']['input']>;
  calculateAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  calculateCrfs?: InputMaybe<Scalars['Boolean']['input']>;
  calculateVisits?: InputMaybe<Scalars['Boolean']['input']>;
  centralMonitoringFirstDataLoadDate?: InputMaybe<Scalars['Date']['input']>;
  centralMonitoringReleaseDate?: InputMaybe<Scalars['Date']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  controlsAutomationActive?: InputMaybe<Scalars['Boolean']['input']>;
  controlsAutomationColor: ControlsAutomationColor;
  displayRiskOverviewOnStudySummary?: InputMaybe<Scalars['Boolean']['input']>;
  displayStudyOverviewOnStudySummary?: InputMaybe<Scalars['Boolean']['input']>;
  displayStudySiteOverviewOnStudySummary?: InputMaybe<Scalars['Boolean']['input']>;
  evaluationModelId?: InputMaybe<Scalars['ObjectId']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  importDefinitionsKey?: InputMaybe<Scalars['String']['input']>;
  indications?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  integrationActive?: InputMaybe<Scalars['Boolean']['input']>;
  integrationStudyNumber?: InputMaybe<Scalars['String']['input']>;
  lastSubjectEnrolledDate?: InputMaybe<Scalars['Date']['input']>;
  lastSubjectRandomisedDate?: InputMaybe<Scalars['Date']['input']>;
  lastSubjectScreenedDate?: InputMaybe<Scalars['Date']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  riskAssessmentAwardStartDate?: InputMaybe<Scalars['Date']['input']>;
  riskAssessmentIsmpStartDate?: InputMaybe<Scalars['Date']['input']>;
  riskAssessmentRfpStartDate?: InputMaybe<Scalars['Date']['input']>;
  riskLibraryCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  riskOverviewConfiguration?: InputMaybe<StudyRiskOverviewConfigurationInput>;
  riskReviewWindowDays?: InputMaybe<Scalars['ConvertableInt']['input']>;
  scoreAmberThreshold?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  scoreGreenThreshold?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  scoreThreshold?: InputMaybe<Scalars['ConvertableFloat']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  siteSummaryConfiguration?: InputMaybe<StudySiteSummaryConfigurationInput>;
  sitesStatusesToExclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sitesStatusesToExcludeFromAutomation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sitesToExclude?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  sponsor?: InputMaybe<Scalars['String']['input']>;
  studyAutomationColor: StudyAutomationColor;
  studyFunctionIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  studyNumber?: InputMaybe<Scalars['String']['input']>;
  studyOverviewTableConfiguration?: InputMaybe<StudyOverviewTableConfigurationInputType>;
  studyReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  studySiteOverviewTableConfiguration?: InputMaybe<StudySiteOverviewTableConfigurationInputType>;
  studySummaryConfiguration?: InputMaybe<StudySummaryConfigurationInput>;
  svtDependency?: InputMaybe<SvtDependencyType>;
  title?: InputMaybe<Scalars['String']['input']>;
  useInformedConsentedDate?: InputMaybe<Scalars['Boolean']['input']>;
  useLatestCentralMonitoring?: InputMaybe<Scalars['Boolean']['input']>;
  volumeAdjustedScoring?: InputMaybe<Scalars['Boolean']['input']>;
  volumeAdjustedScoringNumberField?: InputMaybe<Scalars['String']['input']>;
};

export type StudyMemberInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultSiteId?: InputMaybe<Scalars['ObjectId']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  favourite?: InputMaybe<Scalars['Boolean']['input']>;
  favouriteSiteIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  status?: InputMaybe<StudyMemberStatus>;
  userId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export enum StudyMemberStatus {
  DISABLED = 'DISABLED',
  INVITED = 'INVITED',
  JOINED = 'JOINED',
  VIRTUAL = 'VIRTUAL'
}

export type StudyOverviewColumnConfigurationInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  dataSource?: InputMaybe<RowDataSourceTable>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<OverviewColumnConfigurationEnumType>;
};

export type StudyOverviewExtraColumnInput = {
  columnId?: InputMaybe<Scalars['ObjectId']['input']>;
  dataField?: InputMaybe<Scalars['String']['input']>;
  dataSource?: InputMaybe<RowDataSourceTable>;
  denominatorField?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  numeratorField?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StudyOverviewExtraColumnType>;
};

export enum StudyOverviewExtraColumnType {
  RATE = 'RATE',
  STUDY_MEAN = 'STUDY_MEAN',
  STUDY_MEDIAN = 'STUDY_MEDIAN'
}

export type StudyOverviewPanelConfigurationInput = {
  panelId?: InputMaybe<Scalars['ObjectId']['input']>;
  panelOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type StudyOverviewTableConfigurationInputType = {
  columnConfigurations?: InputMaybe<Array<InputMaybe<StudyOverviewColumnConfigurationInput>>>;
  panelConfigurations?: InputMaybe<Array<InputMaybe<StudyOverviewPanelConfigurationInput>>>;
};

export type StudyRiskOverviewConfigurationInput = {
  amberDecisionKris?: InputMaybe<Scalars['Boolean']['input']>;
  amberKris?: InputMaybe<Scalars['Boolean']['input']>;
  numSubjects?: InputMaybe<Scalars['Boolean']['input']>;
  redDecisionKris?: InputMaybe<Scalars['Boolean']['input']>;
  redKris?: InputMaybe<Scalars['Boolean']['input']>;
  siteActiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  siteCountry?: InputMaybe<Scalars['Boolean']['input']>;
  siteMonitor?: InputMaybe<Scalars['Boolean']['input']>;
  siteStatus?: InputMaybe<Scalars['Boolean']['input']>;
  subjectField?: InputMaybe<Scalars['String']['input']>;
};

export type StudySiteOverviewColumnConfigurationInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  dataSource?: InputMaybe<RowDataSourceTable>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<OverviewColumnConfigurationEnumType>;
};

export type StudySiteOverviewTableConfigurationInputType = {
  columnConfigurations?: InputMaybe<Array<InputMaybe<StudySiteOverviewColumnConfigurationInput>>>;
  panelConfigurations?: InputMaybe<Array<InputMaybe<StudyOverviewPanelConfigurationInput>>>;
  rowOrder?: InputMaybe<OverviewRowOrderConfigurationEnumType>;
};

export type StudySiteSummaryConfigurationInput = {
  actionChart?: InputMaybe<Scalars['Boolean']['input']>;
  monitor?: InputMaybe<Scalars['Boolean']['input']>;
  numCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  numEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  numRandomised?: InputMaybe<Scalars['Boolean']['input']>;
  numScreenFailed?: InputMaybe<Scalars['Boolean']['input']>;
  numScreened?: InputMaybe<Scalars['Boolean']['input']>;
  numStudyDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  numTreatmentDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  observationChart?: InputMaybe<Scalars['Boolean']['input']>;
  siteActiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  siteCountry?: InputMaybe<Scalars['Boolean']['input']>;
  siteStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudySubjectVisitInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  forecastEndDateField?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  isEndDateEarliest?: InputMaybe<Scalars['Boolean']['input']>;
  leadPeriod?: InputMaybe<Scalars['ConvertableInt']['input']>;
  leadUnit?: InputMaybe<StudyTimeUnit>;
  leadVisitId?: InputMaybe<Scalars['ObjectId']['input']>;
  leadVisitName?: InputMaybe<Scalars['String']['input']>;
  maxOccurrences?: InputMaybe<Scalars['ConvertableInt']['input']>;
  maxWinPeriod?: InputMaybe<Scalars['ConvertableInt']['input']>;
  maxWinUnit?: InputMaybe<StudyTimeUnit>;
  minOccurrences?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minWinPeriod?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minWinUnit?: InputMaybe<StudyTimeUnit>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  sequenceNumber?: InputMaybe<Scalars['ConvertableInt']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
  visitName?: InputMaybe<Scalars['String']['input']>;
};

export type StudySubjectVisitScheduleTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cohortIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  studyId?: InputMaybe<Scalars['ObjectId']['input']>;
  treatmentArmIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectId']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
  versionDate?: InputMaybe<NullablePartialDateTimeInput>;
};

export type StudySubjectVisitSequenceInputType = {
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  visitId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type StudySummaryConfigurationInput = {
  numCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  numEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  numRandomised?: InputMaybe<Scalars['Boolean']['input']>;
  numScreenFailed?: InputMaybe<Scalars['Boolean']['input']>;
  numScreened?: InputMaybe<Scalars['Boolean']['input']>;
  numStudyDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  numTreatmentDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StudyTimeUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NONE = 'NONE',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export type StudyTreatmentArmInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  configId?: InputMaybe<Scalars['ObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['ConvertableLong']['input']>;
  subjectCode?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectHubConfigField = {
  displayIndex?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum SubjectPDClassification {
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  NONE = 'NONE'
}

export type SubjectProfileDetailsConfigurationItemInput = {
  personalInformation?: InputMaybe<SubjectProfileDetailsConfigurationItemPersonalInformationInput>;
  siteInformation?: InputMaybe<SubjectProfileDetailsConfigurationItemSiteInformationInput>;
  subjectStatus?: InputMaybe<SubjectProfileDetailsConfigurationItemSubjectStatusInput>;
  timeline?: InputMaybe<SubjectProfileDetailsConfigurationItemTimelineInput>;
  treatmentStatus?: InputMaybe<SubjectProfileDetailsConfigurationItemTreatmentStatusInput>;
};

export type SubjectProfileDetailsConfigurationItemPersonalInformationInput = {
  ageAtEnrolment?: InputMaybe<Scalars['Boolean']['input']>;
  ethnicity?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  latestConsentDate?: InputMaybe<Scalars['Boolean']['input']>;
  latestConsentVersion?: InputMaybe<Scalars['Boolean']['input']>;
  race?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectProfileDetailsConfigurationItemSiteInformationInput = {
  activeDate?: InputMaybe<Scalars['Boolean']['input']>;
  closedDate?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['Boolean']['input']>;
  investigatorName?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  monitor?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfAESIs?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfAEs?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPDs?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfQueriesOpenAll?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfSAEs?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  subjectEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  subjectRandomized?: InputMaybe<Scalars['Boolean']['input']>;
  subjectTxDisc?: InputMaybe<Scalars['Boolean']['input']>;
  subjectTxStart?: InputMaybe<Scalars['Boolean']['input']>;
  subjectsFUComplete?: InputMaybe<Scalars['Boolean']['input']>;
  subjectsFUStart?: InputMaybe<Scalars['Boolean']['input']>;
  subjectsScreenFailed?: InputMaybe<Scalars['Boolean']['input']>;
  subjectsScreened?: InputMaybe<Scalars['Boolean']['input']>;
  subjectsTxComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectProfileDetailsConfigurationItemSubjectStatusInput = {
  combiAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  combiVisits?: InputMaybe<Scalars['Boolean']['input']>;
  enrolled?: InputMaybe<Scalars['Boolean']['input']>;
  fUCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  fUStart?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastVisitNameAndDate?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfAESIs?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfAEs?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPDs?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfQueriesOpenAll?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfSAEs?: InputMaybe<Scalars['Boolean']['input']>;
  randomized?: InputMaybe<Scalars['Boolean']['input']>;
  screenFail?: InputMaybe<Scalars['Boolean']['input']>;
  screenFailReason?: InputMaybe<Scalars['Boolean']['input']>;
  screening?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  studyDisc?: InputMaybe<Scalars['Boolean']['input']>;
  studyDiscReason?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubjectProfileDetailsConfigurationItemTimelineInput = {
  endDateFields?: InputMaybe<Array<Scalars['String']['input']>>;
  milestoneDateFields?: InputMaybe<Array<Scalars['String']['input']>>;
  panels?: InputMaybe<Array<SubjectProfileDetailsConfigurationItemTimelinePanelInput>>;
  showTagsAsMilestones?: InputMaybe<Scalars['Boolean']['input']>;
  sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type SubjectProfileDetailsConfigurationItemTimelinePanelInput = {
  id: Scalars['ObjectId']['input'];
  plotTitle: Scalars['String']['input'];
};

export type SubjectProfileDetailsConfigurationItemTreatmentStatusInput = {
  cohort?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  treatmentArm?: InputMaybe<Scalars['Boolean']['input']>;
  txCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  txDisc?: InputMaybe<Scalars['Boolean']['input']>;
  txDiscReason?: InputMaybe<Scalars['Boolean']['input']>;
  txStart?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SubjectQueryType {
  MANUAL = 'MANUAL',
  SYSTEM = 'SYSTEM'
}

export enum SubjectVisitStatus {
  COMPLETED = 'COMPLETED',
  MISSING = 'MISSING',
  NONE = 'NONE',
  NOT_DONE = 'NOT_DONE',
  SCHEDULED = 'SCHEDULED',
  UNSCHEDULED = 'UNSCHEDULED'
}

export enum SvtDependencyType {
  BOTH = 'BOTH',
  COHORTS = 'COHORTS',
  NONE = 'NONE',
  TREATMENT_ARMS = 'TREATMENT_ARMS'
}

export enum ThresholdCalculation {
  MEAN_SD = 'MEAN_SD',
  POISSON = 'POISSON',
  STUDY_SPECIFIC = 'STUDY_SPECIFIC'
}

export enum TimeFrequencyType {
  ANNUALLY = 'ANNUALLY',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  NONE = 'NONE',
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY'
}

export enum TimelineAxisType {
  DATE = 'DATE',
  NONE = 'NONE',
  NUMERIC = 'NUMERIC'
}

export enum TimelineDateSeriesType {
  DATE_RANGE = 'DATE_RANGE',
  SINGLE_DATE = 'SINGLE_DATE'
}

export enum TimelineFieldLogicalOperator {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  ENDS_WITH = 'ENDS_WITH',
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  IS_BLANK = 'IS_BLANK',
  IS_NOT_BLANK = 'IS_NOT_BLANK',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  STARTS_WITH = 'STARTS_WITH'
}

export type TimelineInput = {
  leftAxis: AxisInput;
  rightAxis?: InputMaybe<AxisInput>;
};

export enum TimelineNumericSeriesType {
  LINE = 'LINE',
  SCATTER = 'SCATTER'
}

export type TimelineRuleInput = {
  field1: Scalars['String']['input'];
  field2?: InputMaybe<Scalars['String']['input']>;
  logicalOperator?: InputMaybe<TimelineRuleLogicalOperator>;
  operator1: TimelineFieldLogicalOperator;
  operator2?: InputMaybe<TimelineFieldLogicalOperator>;
  value1?: InputMaybe<Scalars['_Any']['input']>;
  value2?: InputMaybe<Scalars['_Any']['input']>;
};

export enum TimelineRuleLogicalOperator {
  AND = 'AND',
  OR = 'OR'
}

export enum Transport {
  BROWSER = 'BROWSER',
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

export type TriOpDateParametersInput = {
  amberMaxScore?: InputMaybe<Scalars['ConvertableInt']['input']>;
  amberThreshold?: InputMaybe<Scalars['Float']['input']>;
  bigRedThreshold?: InputMaybe<Scalars['Float']['input']>;
  dataInclusionPeriod?: InputMaybe<PanelTimePeriod>;
  dataInclusionUnit?: InputMaybe<Scalars['ConvertableInt']['input']>;
  dataPopulation?: InputMaybe<DataPopulation>;
  greenMaxScore?: InputMaybe<Scalars['ConvertableInt']['input']>;
  minDataNeeded?: InputMaybe<Scalars['ConvertableInt']['input']>;
  redThreshold?: InputMaybe<Scalars['Float']['input']>;
  rowData?: InputMaybe<Scalars['String']['input']>;
  siteAverage?: InputMaybe<SiteAverage>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  stableValue?: InputMaybe<Scalars['Float']['input']>;
  stableVariableType?: InputMaybe<StableVariableType>;
  thresholdCalculation?: InputMaybe<ThresholdCalculation>;
  xAxisTitle?: InputMaybe<Scalars['String']['input']>;
  yAxisColumnValue?: InputMaybe<Scalars['String']['input']>;
  yAxisDataField?: InputMaybe<Scalars['String']['input']>;
  yAxisTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentInput = {
  content: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
  replySelectors: Array<SelectorData>;
};

export type UpdateCommentReplyInput = {
  content: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
  replySelectors: Array<SelectorData>;
};

export type UpdatedCommentsByIdInput = {
  commentIds: Array<Scalars['ObjectId']['input']>;
  commentSelectors: Array<CommentSelector>;
  entityType: Scalars['String']['input'];
  parentId: Scalars['ObjectId']['input'];
};

export type UpdatedCommentsInput = {
  commentSelectors: Array<CommentSelector>;
  entityType: Scalars['String']['input'];
  parentId: Scalars['ObjectId']['input'];
};

export enum UserLevel {
  ORGANISATION = 'ORGANISATION',
  SYSTEM = 'SYSTEM'
}

export enum UserStatus {
  JOINED = 'JOINED',
  VERIFYING = 'VERIFYING'
}
